angular.module('GlobalHelpersModule').filter "brToNewline", ->
  (block) ->
    if block?
      return block.split('\\.br\\').join('\n');
    else
      ""
